import {
    Service
  } from '../service.js'
  import {
    env
  } from '../env.js'
  
  export class TotalizadoresPorUsuarioService extends Service {
    constructor(controleDeInstancia) {
      super(controleDeInstancia);
      this.url = env.url + "totalizador/dashboard-user";
    }
  
    async listar(objetoDeFiltros, removerPagina = false) {
      if(removerPagina) {
        delete objetoDeFiltros.pagina;
      }
      const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
      return super.get(this.url + queryString);
    }
  
  }
  
  export const totalizadoresPorUsuarioService = new TotalizadoresPorUsuarioService()
  